"use client";

import { useUser } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import EmptyCartSvg from "@/assets/icons/empty-cart.svg";
import { Button } from "@/components/ui/button";
import { useOpenAuthDialog } from "@/features/auth/hooks/use-open-auth-dialog";
import { revalidateCustomPage } from "@/lib/server/revalidate-path";

export const GuestLoginSection = ({
  setOpen,
}: {
  setOpen: (open: boolean) => void;
}) => {
  const { isSignedIn } = useUser();
  const t = useTranslations();
  const pathname = usePathname();
  const openAuthDialog = useOpenAuthDialog();

  useEffect(() => {
    if (isSignedIn) {
      revalidateCustomPage(pathname);
    }
  }, [isSignedIn]);

  if (isSignedIn) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-4 py-10">
      <EmptyCartSvg />
      <header className="text-center font-medium text-2xl">
        {t("discounts.guestLogin.title")}
      </header>
      <div className="text-center font-medium text-lg">
        <Button
          className="h-12 border-brand-green2-300 px-6 py-3 text-base text-brand-green2-300"
          onClick={() => {
            setOpen(false);
            openAuthDialog("login");
          }}
          variant="outline"
        >
          {t("discounts.guestLogin.cta")}
        </Button>
      </div>
    </div>
  );
};
